import USER from './user'
import ACCOUNT from './account'
import ACCOUNT_TYPE from './account-type'
import DETAIL from './detail'
import NETWORK from './network'
import POST from './post'
import POST_OCR_LOGO from './posts-ocr-logo'
import STORIES from './stories'
import CATEGORY from './category'
import INTERACTION from './interaction'
import COMMENT from './comment'
import ANALYSIS from './analysis'
import DASHBOARD from './dashboard'
import EVOLUTION from './evolution'
import ACCOUNT_GROUP from './account-group'
import ACTIVITY from './activity'
import USER_TO_ACCOUNT from './user-to-account'
import EXPORT from './export'
import POST_CATEGORY from './post-to-post-category'

export default {
	USER,
	EXPORT,
	ACTIVITY,
	ACCOUNT,
	ACCOUNT_TYPE,
	ANALYSIS,
	CATEGORY,
	INTERACTION,
	COMMENT,
	DASHBOARD,
	DETAIL,
	NETWORK,
	POST,
	POST_OCR_LOGO,
	STORIES,
	EVOLUTION,
	ACCOUNT_GROUP,
	USER_TO_ACCOUNT,
	POST_CATEGORY,
}
